export default {
  searchText: "",
};
